export default {
  searchText: "",
};
